import { Team } from '@graphql/generated';

interface ComputeShowNoMembersBannerArgs {
  bannerDismissed: boolean;
  pendingRequestInitialLoading: boolean;
  teamLoading: boolean;
  team: Pick<Team, 'users' | 'personal'> | undefined;
  pendingInvitationsCount: number;
}

// TA-10280 regression: TeamDetailPage/index.web.tsx no longer blanks the
// whole page behind a full-page spinner while `team` loads, so MembersTab
// can now mount while `team` is truthy but its `users` field hasn't
// resolved yet — `team.users.length` (no `?.`) crashed on that transient
// shape. `users` is optional-chained here on purpose.
export const computeShowNoMembersBanner = ({
  bannerDismissed,
  pendingRequestInitialLoading,
  teamLoading,
  team,
  pendingInvitationsCount,
}: ComputeShowNoMembersBannerArgs): boolean =>
  !bannerDismissed &&
  !pendingRequestInitialLoading &&
  !teamLoading &&
  !!team &&
  team.users?.length === 1 &&
  pendingInvitationsCount === 0 &&
  !team.personal;
